import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { row } from "@ui/style";
import React, { useMemo } from "react";
import { Button } from "@ui/components/buttons/button";
import { WordingKey } from "@typings/i18n-typings";
import { translationsManager } from "@core/service-container";

interface InviteSurveyProps {
	nextStepSurvey: () => void;
	onClose: () => void;
	surveyWordingKeys: {
		popupBodyKey: WordingKey;
		popupPrimaryCtaKey: WordingKey;
		popupSecondaryCtaKey: WordingKey;
	};
}

export const InviteSurvey: React.FC<InviteSurveyProps> = ({ nextStepSurvey, onClose, surveyWordingKeys }) => {
	const { format, locale } = useI18n();

	const { popupBody, popupPrimaryCta, popupSecondaryCta } = useMemo(() => {
		const translations = translationsManager.getLocaleWordings(locale);
		return {
			popupBody:
				surveyWordingKeys.popupBodyKey in translations
					? translations[surveyWordingKeys.popupBodyKey]
					: format("survey.popup.nps.body"),
			popupPrimaryCta:
				surveyWordingKeys.popupPrimaryCtaKey in translations
					? translations[surveyWordingKeys.popupPrimaryCtaKey]
					: format("survey.popup.nps.cta.shareYourFeedback"),
			popupSecondaryCta:
				surveyWordingKeys.popupSecondaryCtaKey in translations
					? translations[surveyWordingKeys.popupSecondaryCtaKey]
					: format("survey.popup.nps.cta.notNow"),
		};
	}, [format, locale, surveyWordingKeys]);

	return (
		<>
			<p>{popupBody}</p>
			<ButtonContainer>
				<Button uiStyle="secondary" label={popupSecondaryCta} id="closeMe" onClick={onClose} />
				<Button label={popupPrimaryCta} onClick={nextStepSurvey} />
			</ButtonContainer>
		</>
	);
};

const ButtonContainer = styled.div`
	padding-top: 16px;
	${row("S", "spacebetween")};
`;
